import service from "@/api/service";
import { GetResponse } from "@/api/stamp-ticket-preview/response";
import { GetRequest } from "@/api/stamp-ticket-preview/request";

/**
 * スタンプ特典チケットプレビューAPIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/stamp-ticket-preview", getRequest);
  return response.data as GetResponse;
}
